export const SET_IS_FOLLOWING = 'SET_IS_FOLLOWING'